import { render, staticRenderFns } from "./HistorySgp.vue?vue&type=template&id=8b6db51a"
import script from "./HistorySgp.vue?vue&type=script&lang=js"
export * from "./HistorySgp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports